module.exports = {"420529111":"渔洋关镇","420529112":"仁和坪镇","420529113":"长乐坪镇","420529114":"五峰镇","420529115":"湾潭镇","420529201":"付家堰乡","420529202":"牛庄乡","420529203":"采花乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420529.json
// module id = 1857
// module chunks = 0